var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShieldChevron = function SvgIconShieldChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 3.5a1.75 1.75 0 0 0-1.75 1.75v5.503c0 8.562 7.27 11.395 8.688 11.867.364.13.76.13 1.124 0 1.418-.472 8.688-3.305 8.688-11.867V5.25A1.75 1.75 0 0 0 19.5 3.5zm.25 7.253V5.5h14.5v5.253c0 1.488-.261 2.77-.687 3.872l-5.989-4.194a1 1 0 0 0-1.147 0l-5.99 4.194c-.426-1.101-.687-2.383-.687-3.872m1.611 5.667c1.833 2.782 4.694 3.955 5.639 4.279.945-.325 3.806-1.497 5.639-4.28L12 12.471z",
    clipRule: "evenodd"
  })));
};
export default SvgIconShieldChevron;